import { ReportTableColumn } from '../models/report-table-column.model';

export const InvoiceDataTable: ReportTableColumn[] = [
  {
    displayName: 'Customer Name',
    columnName: 'customer-name',
    propertyName: 'Customer Name (Number)',
    width: 'wide',
  },
  {
    displayName: 'Invoice Number',
    columnName: 'invoice-number',
    propertyName: 'Invoice Number',
    width: 'medium',
  },
  {
    displayName: 'Invoice Date',
    columnName: 'invoice-date',
    propertyName: 'Invoice Date',
    width: 'narrow',
  },
  {
    displayName: 'Order #',
    columnName: 'order-number',
    propertyName: 'Order Number',
    width: 'narrow',
  },
  {
    displayName: 'Order Date',
    columnName: 'order-date',
    propertyName: 'Order Date',
    width: 'narrow',
  },
  {
    displayName: 'Purchase Order #',
    columnName: 'purchase-order-number',
    propertyName: 'Purchase Order Number',
    width: 'medium',
  },
  {
    displayName: 'Transaction Type',
    columnName: 'transaction-type',
    propertyName: 'Transaction Type',
    width: 'medium',
  },
  {
    displayName: 'Extended Price',
    columnName: 'extended-price',
    propertyName: 'Extended Price',
    width: 'medium',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Sales Tax',
    columnName: 'sales-tax',
    propertyName: 'Sales Tax',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Product Allowance',
    columnName: 'product-allowance',
    propertyName: 'Product Allowance',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Product Charge',
    columnName: 'product-charge',
    propertyName: 'Product Charge',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Remittance Amount',
    columnName: 'remittance-amount',
    propertyName: 'Remittance Amount',
    width: 'medium',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Cases Ordered',
    columnName: 'cases-ordered',
    propertyName: 'Cases Ordered',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Cases Purchased',
    columnName: 'cases-purchased',
    propertyName: 'Cases Purchased',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Eaches Ordered',
    columnName: 'eaches-ordered',
    propertyName: 'Eaches Ordered',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Eaches Purchased',
    columnName: 'eaches-purchased',
    propertyName: 'Eaches Purchased',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
];
